import { QueryKey, UseQueryOptions, useQueryClient } from '@tanstack/react-query';
import { useLocalStorageState } from 'ahooks';
import {
  TASKS_DISABLED_BOAT_RECORDS,
  TASKS_TABLE_ORDER,
  TWO_HOURS_IN_MILLISECONDS,
  TWO_MINUTES_IN_MILLISECONDS,
} from 'mdc-constants';
import { useGraphQLClient } from 'providers';
import { useMemo } from 'react';
import { GetTask, GetTaskVariables, GetTasks, useGetTask } from '../graphql';
import useAccessToken from './useAccessToken';

export default function useTask(
  itemTaskId?: string,
  options?: UseQueryOptions<GetTask, unknown, GetTask, QueryKey> | undefined,
) {
  const queryClient = useQueryClient();
  const { data: accessToken } = useAccessToken();
  const { graphQLClient } = useGraphQLClient(accessToken);

  const variables: GetTaskVariables = {
    id: itemTaskId || '',
  };

  const localInitialData = useMemo(() => {
    const tasksQueries = queryClient.getQueriesData<GetTasks>({ queryKey: ['getTasks'], exact: false });

    let initialTaskData;

    for (let i = 0; i < tasksQueries.length; i += 1) {
      const [_f, taskData] = tasksQueries[i];
      const task = taskData?.tasks?.data.find((item) => item.id === variables.id);

      if (task) {
        initialTaskData = { task };
        break;
      }
    }

    // console.log('The initial alert data', initialTaskData);

    return initialTaskData;
  }, [queryClient, variables.id]);

  const queryInfo = useGetTask(graphQLClient, variables, {
    ...options,
    gcTime: TWO_HOURS_IN_MILLISECONDS,
    staleTime: TWO_MINUTES_IN_MILLISECONDS,
    enabled: !!accessToken && !!itemTaskId,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    initialData: (localInitialData as GetTask | undefined) || options?.initialData,
  });

  return {
    ...queryInfo,
  };
}
